import React from "react";
import DialogPopup from "@_components/DialogPopup/DialogPopup";
import Button from "@mui/material/Button";
import styles from "./AreYouSurePopup.module.css";
import { CircularProgress } from "@mui/material";
function AreYouSurePopup(props) {
  return (
    <DialogPopup
      onKeyUp={(e) => {
        if (e.key === "Enter") {
          props.onClick();
        }
      }}
      title={props.title ? props.title : ""}
      open={props.open}
      onClose={() => props.close()}
    >
      <div className={styles.content_container}>{props.children}</div>
      <div className="action_container">
        {props.isLoading ? (
          <div className={styles.loading}>
            <CircularProgress />
          </div>
        ) : (
          <>
            <Button className="btn_cancel" onClick={() => props.close()}>
              {props.cancelBtn ? props.cancelBtn : "No"}
            </Button>
            <Button
              className={`btn_confirm ${
                props.confirmDisabled ? "btn_disabled" : ""
              }`}
              disabled={props.confirmDisabled ? props.confirmDisabled : false}
              onClick={props.onClick}
            >
              {props.confirmBtn ? props.confirmBtn : "Yes"}
            </Button>
          </>
        )}
      </div>
    </DialogPopup>
  );
}

export default AreYouSurePopup;
